import { FC } from 'react'
import { IconProps } from '@chakra-ui/react'

import { UserHexagon } from 'components/icons'

type Props = IconProps

const Place: FC<Props> = (props) => {
  return <UserHexagon {...props} />
}

const PlaceExports = {
  Place,
}

export default PlaceExports
